enum Color {
  Text = 'text',
  TextSecondary = 'textSecondary',
  White = 'white',

  TableBorder = 'tableBorder',
  TableBackground = 'tableBackground',
  LightBackground = 'lightBackground',
  GrayBackground = 'grayBackground',
  InputBackground = 'inputBackground',
  Overlay = 'overlay',
  DisabledLabel = 'disabledLabel',

  Primary = 'primary',
  PrimaryHover = 'primaryHover',
  Active = 'active',
  Link = 'link',

  Error = 'error',
  ErrorBackground = 'errorBackground',
  Success = 'success',
  SuccessBackground = 'successBackground',
  Warning = 'warning',
  WarningBackground = 'warningBackground',

  InputBorder = 'inputBorder',

  Brand = 'brand',
}

export const TextColors = {
  [Color.Text]: 'text-text',
  [Color.TextSecondary]: 'text-textSecondary',
  [Color.White]: 'text-white',

  [Color.Primary]: 'text-primary',
  [Color.Link]: 'text-link',
  [Color.DisabledLabel]: 'text-disabledLabel',
  [Color.Active]: 'text-active',

  [Color.Error]: 'text-error',
  [Color.Success]: 'text-success',
  [Color.Warning]: 'text-warning',

  [Color.Brand]: 'text-brand',
};

export const BorderColors = {
  [Color.Primary]: 'border-primary',
  [Color.Active]: 'border-active',
  [Color.TableBorder]: 'border-tableBorder',
  [Color.Text]: 'border-text',
  [Color.TableBackground]: 'border-tableBackground',
  [Color.Brand]: 'border-brand',
  [Color.InputBorder]: 'border-inputBorder',
  [Color.Warning]: 'border-warning',
  [Color.Error]: 'border-error',
};

export const BackgroundColors = {
  [Color.Overlay]: 'bg-overlay',
  [Color.Primary]: 'bg-primary',
  [Color.Active]: 'bg-active',
  [Color.TableBackground]: 'bg-tableBackground',
  [Color.LightBackground]: 'bg-lightBackground',
  [Color.GrayBackground]: 'bg-grayBackground',
  [Color.InputBackground]: 'bg-inputBackground',
  [Color.White]: 'bg-white',
  [Color.Brand]: 'bg-brand',
  [Color.ErrorBackground]: 'bg-errorBackground',
  [Color.WarningBackground]: 'bg-warningBackground',
  [Color.SuccessBackground]: 'bg-successBackground',
};

export const HoverColors = {
  Background: {
    [Color.TableBackground]: 'hover:bg-tableBackground',
    [Color.PrimaryHover]: 'hover:bg-opacity-38',
  },
};

export const Gradient = {
  TextToWhite: 'bg-gradient-to-r from-text to-white',
};

export default Color;
